import { GET_MAP_LOCATIONS } from './map.types';

/**
 * Load client + staff pins for the Clients & Staff Map. `params` carries the server-side filters
 * (`staffStatuses` / `clientStatuses`); omitted, the API plots its default (active) statuses.
 */
export const getMapLocations = (params, load) => {
    return {
        type: GET_MAP_LOCATIONS,
        payload: { params, load },
    };
};
